import styled, { css } from 'styled-components'

import { Type } from 'bl-common/src/elements/Typography/Typography'
import { Section } from 'bl-common/src/units/Section/Section'
import { media } from 'bl-common/src/utils/media'
import { mixins } from 'bl-common/src/utils/mixins'

const Svg = styled.svg`
  position: absolute;
  width: 30px;
  left: -16px;
  transform: translateX(-100%);

  ${media.md(css`
    width: 45px;
    left: 0;
  `)}
`

export const BlockQuote = styled(({ ...rest }) => (
  <Type as="blockquote" {...rest} />
))`
  position: relative;

  ${media.md(css`
    width: calc((10 / 12) * 100%);
    padding-left: ${mixins.span({ columns: 0, gutters: 1 })};
  `)}
`

const Mark = () => (
  <Svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 37">
    <path
      d="M44.6 30.4l-1-12-10-2.4L36 .8 31 0l-4 2-2.4 11v11.8l1.2 11.8h11.6l6.4-1.6.8-4.6zm-24.6 0l-1-12L9 16 11.4.8l-5-.8-4 2L0 13v11.8l1 11.8h11.6L19 35l1-4.6z"
      fill="#52A5B8"
    />
  </Svg>
)

const StoryBlockQuote = ({ text, footer }) => {
  return (
    <Section>
      <BlockQuote top={{ xs: 2, md: 2 }} bottom={{ xs: 1, md: 2 }}>
        <Mark />
        <Type size={{ xs: 16, md: 28, lg: 30 }} weight="light">
          {text}
        </Type>
        <Type top={{ xs: 2, md: 2 }} preset="label">
          {footer}
        </Type>
      </BlockQuote>
    </Section>
  )
}

export default StoryBlockQuote
